// TODO: Move this under MenuProductCard

import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

export interface IProductPackageCardGroupUIStateProps {
    plans: IMenuCardPlan[];
    cardId: string;
    onChange: any;
}

export interface IProductPackageCardGroupUIDispatchProps {
}

export interface IProductPackageCardGroupUIProps extends
    IProductPackageCardGroupUIStateProps,
    IProductPackageCardGroupUIDispatchProps {
}

export interface IProductPackageCardGroupUIState {
}

export interface IMile {
    termId: number;
    mileage: number;
}

export interface ITerms {
    term: number;
    miles: IMile[];
}

import { IMenuCardPlan } from '../../features/MenuProductCard/types';

export default class ProductPackageCardGroupUI extends Component<IProductPackageCardGroupUIProps, IProductPackageCardGroupUIState> {
    static propTypes = {
        plansArray: PropTypes.array,
        cardId: PropTypes.string
    };

    handleClick(value: string) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    buildProductPackageCard(planObject: IMenuCardPlan, index, cardId) {
        return (
            <div key={index} className="dr-product-package-card">
                <div className="card-header" onClick={() => { this.handleClick(planObject.description); }}>
                    <div className="card-title">
                        {planObject.description}<br />
                        {/*$45/mo<br />*/}
                        {/*<span>Plan total $9,999</span>*/}
                        <span>Plan total $--</span>
                    </div>
                    <div className="header-radio-button">
                        <div className={`product-package-radio ${planObject.isSelected ? 'isChecked' : ''}`}></div>
                    </div>
                </div>
                <div className="card-body">
                    Month from<br />
                    Miles from<br />
                    Eligibility<br />
                    Odometer Eligibility<br />
                </div>
            </div>
        );
    }

    buildProductPackageCardGroup(plans: IMenuCardPlan[], cardId: string) {
        return plans.map((plan, index) => this.buildProductPackageCard(plan, index, cardId));
    }

    render() {
        const {
            plans,
            cardId
        } = this.props;

        const ProductPackageCardGroup = this.buildProductPackageCardGroup(plans, cardId);

        return (
            <div className="product-package-card-group">
                {ProductPackageCardGroup}
            </div>
        );
    }
}
